/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TodayPlusDays/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TodayPlusDays({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsertNew/DueDate/TodayPlusDays",
  onChange
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let eventActionDataDueDateValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.due_date',
})
let constantData = 'today_plus_days'
let aggregateData = fromAggregate.equals(eventActionDataDueDateValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onChange
  
})
let eventActionDataDueDateDaysValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.due_date_days',
})
let eventActionDataDueDateDaysChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.due_date_days',
})
let eventActionDataDueDateValueData1 = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.due_date',
})
let constantData1 = 'today_plus_days'
let aggregateData1 = fromAggregate.equals(eventActionDataDueDateValueData1, constantData1)
  return (<React.Fragment
>
<div
  data-testid="TodayPlusDays.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z4FPVt': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="event_action.data.due_date"
 data="'today_plus_days'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 paddingRight={0}
/>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 flexGrow={0}
 marginTop={0}
 type="number"
 width={40}
 data="event_action.data.due_date_days"
 onChange={eventActionDataDueDateDaysChangeData}
 value={eventActionDataDueDateDaysValueData}
 data="event_action.data.due_date"
 data="'today_plus_days'"
 aggregate="/Data/aggregate.js equals"
 disabled={!aggregateData1}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 min={0}
 max={30}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="days from now"
/>
</div>
{children}
</React.Fragment>)
}